import { render, staticRenderFns } from "./CreditNoteListView.vue?vue&type=template&id=634eb8ae"
import script from "./CreditNoteListView.vue?vue&type=script&lang=js"
export * from "./CreditNoteListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports